// extracted by mini-css-extract-plugin
export default {"addresses":"JedXvJIvWwWr7lDzpOqvIg==","DE":"t-Mb8DP5EiaNoqJXs-yYeg=="};